// extracted by mini-css-extract-plugin
export default {"title":"ContactUs_title__4waU3","text":"ContactUs_text__EuJFM","container":"ContactUs_container__RQYWV","linkContainer":"ContactUs_linkContainer__w8CdY"};